import { type Config } from "mixpanel-browser";

// Public browser ingestion tokens, one EU project per build mode. PR previews
// and tests have no project, so they send nothing.
const tokensByMode: Record<string, string> = {
  production: "0c95f76a2c9888f97de23b04de6bf3d7", // Dashboard — Prod (4064739)
  development: "d7f075ed65cd9745260086b6cd572071", // Dashboard — Dev (4064740)
};

export const mixpanelToken: string | undefined =
  tokensByMode[process.env.MODE ?? ""];

export const mixpanelConfig: Partial<Config> = {
  api_host: "https://api-eu.mixpanel.com",
  autocapture: false,
  track_pageview: false,
  record_sessions_percent: 0,
};
